__turbopack_context__.v({
  "animation": "animation-module__sSDOta__animation",
  "error": "animation-module__sSDOta__error",
  "left": "animation-module__sSDOta__left",
  "right": "animation-module__sSDOta__right",
  "solid": "animation-module__sSDOta__solid",
  "toggle": "animation-module__sSDOta__toggle",
  "variables": "animation-module__sSDOta__variables",
  "warning": "animation-module__sSDOta__warning",
});
